var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterMessagesInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 97 97",
    style: {
      enableBackground: "new 0 0 97 97"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3A4F50;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.5,24.5c-0.3-1.4-0.8-2.8-1.6-4C87.3,7.5,74.7,4.3,48.5,4.3C24.6,3.9,12.1,6.7,5.7,16.4 c-0.4,1.2-1.2,2.4-1.6,3.6l3.2-2.4L4.1,20c-0.8,1.4-1.3,2.9-1.6,4.5C0.6,32.3-0.2,40.3,0,48.3c0,36.8,8.5,44.4,48.5,44.4 S97,85.1,97,48.3C97.2,40.3,96.3,32.3,94.5,24.5z M21,14.8c9-2.4,18.2-3.3,27.5-2.8c7.6-0.2,15.1,0.3,22.6,1.6 c4,0.5,7.8,2.2,10.9,4.8c1.2,1.2,2.1,2.5,2.8,4c-2.9,3-6,5.8-9.3,8.5c-4.2,3.6-8.9,6.7-13.7,9.3c-4.2,2.3-8.9,3.7-13.7,4 c-4.8-0.3-9.5-1.7-13.7-4c-4.8-2.6-9.3-5.7-13.3-9.3c-3.3-2.6-6.4-5.5-9.3-8.5C13.5,18.6,16.9,15.8,21,14.8z M82.4,78.2 c-3.1,2.6-6.9,4.3-10.9,4.8c-7.6,1.3-15.3,1.8-23,1.6c-7.6,0.2-15.1-0.3-22.6-1.6c-4-0.5-7.8-2.2-10.9-4.8 c-4.5-3.6-6.9-11.3-6.9-29.9c-0.1-5.7,0.3-11.4,1.2-17c2,2,4.5,4,6.9,6.1c4.7,3.8,9.7,7.2,14.9,10.1c5.3,3,11.3,4.7,17.4,4.8 c6.1-0.2,12.1-1.8,17.4-4.8c5.3-2.8,10.4-6.2,14.9-10.1c2.4-2,4.8-4,6.9-6.1c0.9,5.6,1.3,11.3,1.2,17 C88.9,66.9,86.5,74.6,82.4,78.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMessagesInactive);
export default __webpack_public_path__ + "static/media/FooterMessagesInactive.1c492b41e516f33c65e8917168987c21.svg";
export { ForwardRef as ReactComponent };